module.exports = __webpack_public_path__ + "Lato-MediumItalic.96f828791c07f91c0aa9.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-MediumItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-MediumItalic.ttf
// module chunks = styles